<template>
  <div>
    <!-- Comparativo Franquias Table -->
    <comparativo-franquias-table
      ref="comparativoFranquiasTableRef">
    </comparativo-franquias-table>
  </div>
</template>

<script setup lang="ts">
import { ref, onMounted, onBeforeUnmount } from 'vue';
import { log } from '../../utils/DebugLogger';

interface DataTableInstance {
  loadData: () => void;
}

// Reactive data
const comparativoFranquiasTableRef = ref<DataTableInstance | null>(null);

// Methods
const loadData = async () => {
  if (comparativoFranquiasTableRef.value) {
    await comparativoFranquiasTableRef.value.loadData();
  }
};

// Lifecycle
onMounted(() => {
  log('ComparativoFranquiasPage', 'mounted', 'Component mounted');
});

onBeforeUnmount(() => {
  log('ComparativoFranquiasPage', 'beforeUnmount', 'Cleaning up');
});

// Expose methods for parent components
defineExpose({
  loadData
});
</script>

<style scoped>
</style>
